var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        no: "dialog",
        visible: _vm.innerVisible,
        title: _vm.$t("queryJob.enterSubLabel"),
        width: _vm.$selectByLang("300px", "350px"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-width": _vm.$selectByLang("80px", "130px"),
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("queryJob.subLabel") + "：" } },
            [
              _c("el-input", {
                attrs: { no: "label" },
                model: {
                  value: _vm.warehouseInForm.label,
                  callback: function($$v) {
                    _vm.$set(_vm.warehouseInForm, "label", $$v)
                  },
                  expression: "warehouseInForm.label"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Billing.WayBillNumber") + "：" } },
            [_vm._v(" " + _vm._s(_vm.jobForm.mbl) + " ")]
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Payment.warehouseNo") + "：" } },
            [_vm._v(" " + _vm._s(_vm.warehouseInForm.warehouseNo) + " ")]
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("queryJob.receiptNo") + "：" } },
            [_vm._v(" " + _vm._s(_vm.warehouseInForm.receiptNo) + " ")]
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "Confirm", type: "primary" },
              on: { click: _vm.clickHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "Cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }